export default __webpack_public_path__ + "static/media/linkedin.fd9e4298.svg";